import React, { useState, useEffect } from "react";
import { Card } from "antd";
import { API, THEME, SESSION_TIMEOUT} from "../config/config";
import OtpVerify from "../components/OtpVerify";
import OptionVerify from "../components/OptionVerify";
import Multilingual from "./../helper/Multilingual";
import htmlParser from "html-react-parser";
import md5 from "md5";
import {sha256} from "js-sha256";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

import { Form, Input, Button, Row, Col, ConfigProvider } from "antd";
import FetchUserGroups from "../helper/FetchUserGroups";
import FetchUserAccess from "../helper/FetchUserAccess";
import FetchUserAssociations from "../helper/FetchUserAssociations";

const ResetPassword = (props) => {
    const [t, locale, getDropdownSelectLanguage] = Multilingual();
    const [data, setData] = useState({ username: "", new_password: "", confirm_password: "" });
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null);
    const [otp, setOtp] = useState("");
    const [message, setMessage] = useState("");
    const [isResetPasswordSuccess, setIsResetPasswordSuccess] = useState(false);

    const timeoutAfter = SESSION_TIMEOUT && Number.isInteger(SESSION_TIMEOUT) && SESSION_TIMEOUT > 1 ? SESSION_TIMEOUT : 15;

    const [form] = Form.useForm();

    useEffect(() => {
        document.title = t("resetpassword.title");
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const optionChange = (payload) => {
        setUser({ ...user, ...payload });
    };

    const otpChange = (otp) => {
        setOtp(otp);
    };

    const layout = {
        layout: "vertical",
    };
    const tailLayout = {};

    const formValChange = (chgV, allV) => {
        setData(allV);
    };

    const storeUserDataInCookies = (userdata) => {
        // Cookies can only be so large, so only keep what's necessary there. user id, menu items, remember me, any tokens.
        const authuser = window.btoa(`${userdata.userid}:${userdata.username}`);
        
        Cookies.set("authuser", authuser, { secure: true, sameSite: "Strict"});
        Cookies.set("access", JSON.stringify(userdata.access), { secure: true, sameSite: "Strict"});
        Cookies.set("groups", JSON.stringify(userdata.groups), { secure: true, sameSite: "Strict"});
        Cookies.set("access_token", userdata.access_token, { secure: true, sameSite: "Strict"});
        Cookies.set("associations", JSON.stringify(userdata.associations), { secure: true, sameSite: "Strict"});
        Cookies.set("menu_items", JSON.stringify(userdata.menu_items), { secure: true, sameSite: "Strict" });

        Cookies.set("userid", userdata.userid, { secure: true, sameSite: "Strict" });
        Cookies.set("remember_me", userdata.rememberme, { secure: true, sameSite: "Strict" });
        Cookies.set("verify_option", userdata.verify_option, { secure: true, sameSite: "Strict" });
    };

    const onVerify = async (userbypass = null) => {

        let userdata = null;

        if (user) {
            userdata = user;
        } else if (userbypass) {
            userdata = userbypass;
        } else {
            return false;
        }

        if (!userdata.skip_2fa) {
            const isVerified = await axios
                .post(API + "/otpverify", { otp: otp }, { headers: { Authorization: "Bearer " + user.access_token } })
                .then(({ data }) => data.verify)
                .catch(() => false);

            if (!isVerified) {
                setOtp("");
                Swal.fire({
                    icon: "error",
                    title: t("login.dialogs.verify_error"),
                    showConfirmButton: false,
                    timer: 2000,
                });

                return false;
            }
        }

        let userAccess, userAssociations, userGroups;
        try {
            [userAccess, userAssociations, userGroups] = await Promise.all([
                FetchUserAccess(userdata.access_token, userdata.userid),
                FetchUserAssociations(userdata.access_token, userdata.userid),
                FetchUserGroups(userdata.access_token, userdata.userid)
            ]);
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: t("login.dialogs.catch"),
                showConfirmButton: false,
                timer: 2000,
            });
            return false;
        }
        userdata = {
            ...userdata,
            ...userAccess,
            ...userAssociations,
            ...userGroups
        }

        userdata = { ...userdata, fullName: `${userdata.firstname} ${userdata.lastname}` };
        userdata = { ...userdata, expiry: moment().add(timeoutAfter, "minutes").format() };

        await storeUserDataInCookies(userdata);

        // theme and theme settings (preferred page size etc) in local storage.
        let loggedUser = {
            username: userdata.username,
            email: userdata.email,
            fullname: userdata.fullName,
            firstname: userdata.firstname,
            lastname: userdata.lastname,
            theme: userdata.theme,
            theme_compact: userdata.theme_compact,
            theme_logo: userdata.theme_logo,
            expiry: userdata.expiry,
            password_changed: userdata.password_changed,
        }
        
        loggedUser = { ...loggedUser, validate: md5(JSON.stringify(loggedUser)) };

        localStorage.setItem("loggedUserSettings", userdata.dashboard_settings ? JSON.stringify(userdata.dashboard_settings) : '{}');
        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));

        if (userdata.theme) {
            if (Array.isArray(userdata.theme)) {
                // Removed by Jericho 2023-08-23 - Removing the txshield themes/reseller logo
                // if (userdata.theme[0].logo) {
                //     localStorage.setItem("logo", userdata.theme[0].logo);
                // }
                if (userdata.theme[0].dashboardtheme) {
                    localStorage.setItem("dashboardtheme", userdata.theme[0].dashboardtheme.replaceAll('/"', "'"));
                }
            }
        }
        Swal.fire({
            icon: "success",
            title: t("login.dialogs.login_success"),
            showConfirmButton: false,
            timer: 2000,
            onClose: () => {
                props.history.push("/dashboard");
            },
        });
    };

    const onFinish = (values) => {
        axios
            .post(API + "/resetpassword", { username: values.username, password: sha256(values.new_password), token: token })
            .then(({ data }) => { //eslint-disable-line
                if (!user.skip_2fa) {
                    setIsResetPasswordSuccess(true);
                } else {
                    if(data.status === 'EXC'){
                        Swal.fire({
                            icon: "error",
                            title: data.error_msg,
                            showConfirmButton: true,
                        });
                    }else{
                        Swal.fire({
                            icon: "success",
                            title: t("login.dialogs.password_changed"),
                            showConfirmButton: false,
                            timer: 2000,
                            onClose: () => {
                                props.history.push("/");
                            },
                        });
                    }
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: t("login.dialogs.catch"),
                    text: error.response ? error.response.data.error_msg : "",
                    showConfirmButton: true,
                });
            });
    };

    if (localStorage.getItem("loggedUser")) {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

        if (loggedUser) {
            Cookies.remove("access");
            Cookies.remove("groups");
            Cookies.remove("authuser");
            Cookies.remove("menu_items");
            Cookies.remove("access_token");
            Cookies.remove("associations");
            
            Cookies.remove("userid");
            Cookies.remove("remember_me");
            Cookies.remove("cookie_enabled");
            Cookies.remove("verify_option");
        
            Cookies.remove("oiAssociation");
            Cookies.remove("cbm_token");
            Cookies.remove("threeds_token");
            Cookies.remove("txalert_token");
            Cookies.remove("txfind_token");

            // props.history.push("/dashboard");
            localStorage.clear();
        }
    }

    const getSelectLanguage = () => {
        return (
            <Row type="flex" gutter={[8, 0]} justify="end" style={{ marginBottom: "1rem" }}>
                <Col>{getDropdownSelectLanguage()}</Col>
            </Row>
        );
    };

    const checkToken = (token) => {
        const apiUrl = "/getuserbytoken";
        axios
            .post(API + apiUrl, { token: token })
            .then(({ data }) => {

                if (data.success) {

                    form.setFieldsValue({ username: data.username, new_password: "", confirm_password: "" });
                    setUser(data);
                } else {
                    setMessage(data.message);
                }
            })
            .catch((error) => error);
    };

    if (typeof props.match.params.token != "undefined" && !token) {
        setToken(props.match.params.token);
        checkToken(props.match.params.token);
    }

    return !isResetPasswordSuccess ? (
        <ConfigProvider locale={locale}>
            <div className={`login-warp ${locale.locale}`}>
                <div className="login-warp--box">
                    <img
                        src={`../themes/${THEME ? THEME : "default"}/payshield-origin.png`}
                        width={"100%"}
                        style={{ display: "block", maxWidth: "300px", margin: "0 auto 1rem auto" }}
                        alt="payshield dashboard"
                    />
                    {message !== "" ? (
                        <Card className="text-center" style={{ width: 400 }}>
                            <h2>{t("resetpassword.title")}</h2>
                            <p>{htmlParser(message)}</p>
                        </Card>
                    ) : (
                        <>
                            {getSelectLanguage()}
                            <Form {...layout} form={form} onValuesChange={formValChange} onFinish={() => onFinish(data)}>
                                <Form.Item name="username" rules={[{ required: true, message: t("login.required.username") }]}>
                                    <Input size="large" placeholder={t("login.username")} style={{ backgroundColor: "#eee" }} readOnly={true} />
                                </Form.Item>
                                <Form.Item
                                    name="new_password"
                                    dependencies={["old_password"]}
                                    rules={[
                                        { required: true, message: t("contents.profile.form.required_messages.changepass_new_required") },
                                        { min: 8, message: t("contents.profile.form.required_messages.changepass_new_min8") },
                                    ]}
                                >
                                    <Input.Password size="large" placeholder={t("contents.profile.form.new_password")} />
                                </Form.Item>
                                <Form.Item
                                    name="confirm_password"
                                    dependencies={["new_password"]}
                                    rules={[
                                        { required: true, message: t("contents.profile.form.required_messages.changepass_confirm_required") },
                                        { min: 8, message: t("contents.profile.form.required_messages.changepass_confirm_min8") },
                                        ({ getFieldValue }) => ({
                                            validator(rule, value) {
                                                if (!value || getFieldValue("new_password") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(t("contents.profile.form.required_messages.changepass_confirm_nomatch"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password size="large" placeholder={t("contents.profile.form.confirm_password")} />
                                </Form.Item>
                                <Form.Item {...tailLayout} className="text-center" style={{ marginBottom: ".5rem" }}>
                                    <Button type="primary" htmlType="submit" className="login-form-button" size="large" shape="round">
                                        {t("login.submit")}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </>
                    )}
                </div>
            </div>
        </ConfigProvider>
    ) : !user['skip_2fa'] ? (
        !user["verify_option"] ? (
            <ConfigProvider locale={locale}>
                <OptionVerify t={t} email={user.email} access_token={user.access_token} handleChange={optionChange} />
            </ConfigProvider>
        ) : (
            <ConfigProvider locale={locale}>
                <OtpVerify
                    t={t}
                    otp={otp}
                    handleChange={otpChange}
                    onSubmit={onVerify}
                    option={user["verify_option"]}
                    qrcode={user["2fa_qrcode"]}
                    secret={user["2fa_secret"]}
                    firstlogin_succeed={user["first_time_verify"]}
                />
            </ConfigProvider>
        )
    ) : null;
};

export default ResetPassword;
